import {
  Pause,
  PlayArrow,
  Chat,
  Visibility,
  VisibilityOff,
  Info,
  Sync,
  PlusOneOutlined,
  Add,
  Remove,
} from "@mui/icons-material";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  TextField,
  Stack,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Pagination,
  CircularProgress,
  ThemeProvider,
  createTheme,
  Select,
  MenuItem,
  Button,
  InputAdornment,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// @ts-ignore
import WT from "@sscale/wtsdk";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HokeyPlayIngIcon from "../../../assets/icons/HokeyPlayingIcon";
import BitMovingPlayer from "../../../Common/Component/VideoPlayer/bitMovingPlayer";
import useCommonDetails from "../../../Common/Hooks/useCommonDetails";
import { trackSearch, SEARCH_CONTEXT } from "../../../utils/gaUser";
import ChatComponent from "../ChatComponent";
import ClipsData, { formatTime } from "../ClipsData";
import HighLight from "../HightLight";
import WatchStyle from "../Watch.style";
import { ChatRoom } from "amazon-ivs-chat-messaging";

import { v4 as uuid } from "uuid";
import moment, { duration } from "moment";

import useConfig from "../../../hooks/useConfig";
import { APIRoutes, CATEGORY, INSIDER_PLAN_ID } from "../../../utils/constants";
import { useLocation, useParams, useSearchParams } from "react-router-dom";

import { onValue, ref } from "firebase/database";
import { db, makeGetRequest } from "../../../service";
import Login from "../WatchParty/Login/Login";
import { toast } from "react-toastify";
import { Style } from "./PlayerPage.Style";

import { initializeSyncSdk } from "../../../service/SynchronizeService";
import { handleSubmit, off, on } from "../../../service/PubSub";
import { useDispatch } from "react-redux";
import roomDetails from "../../../store/reducers/roomReducer";
import { WatchContex } from "../watch";
import WatchTogether from "../WatchParty/Session/Session";
import {
  faPeopleArrows,
  faSquarePollHorizontal,
} from "@fortawesome/free-solid-svg-icons";
import VideoPlayerForChannel from "../../PersonalChannel/VideoCard/VideoPlayerForChannel";
import MatchCard from "../../PersonalChannel/MatchCard";
import HttpService from "../../../hooks/Https-services";
import { PersonalChannelApi } from "../../PersonalChannel/PersonalChannel.Api";
import LoadingContext from "../../../Common/Contex/LoadingContex";
import Loader from "../../../Common/Component/Loader";
import { WatchSidebar } from "./WatchSidebar";
import {
  AL_STACK_BREAKPOINT,
  alSidebarGridProps,
  alVideoGridProps,
} from "../../../components/audienceLayerLayout";
import { useAudienceLayerHost } from "./useAudienceLayerHost";
import ClipsButtons from "../ClipsButtons";
import CustomChangeButton from "../CustomChangeButton";
import "../index.css";
import BitMovingPlayerLiniusv2 from "../../PersonalChannel/VideoCard/VideoPlayerForChannelv2";
import { V2Shell } from "@/v2/components/V2Shell";
import { ClipBar } from "@/v2/components/watch/ClipBar";
import {
  CondensedGameClips,
  type StripTeams,
} from "@/v2/components/watch/CondensedGameClips";
import {
  useCondensedGameClips,
  type CondensedClip,
} from "@/v2/components/watch/useCondensedGameClips";
import { useGameSheetBoxScore } from "@/v2/components/watch/useGameSheetBoxScore";
import {
  GameDetailsFallback,
  type TeamNameInfo,
} from "@/v2/components/watch/GameDetailsFallback";
import { search_api_url } from "@/utils/axios";
import { getCurrentAuth } from "../../../hooks/useAxiosPrivate";


/*
 * Land five seconds before a moment rather than on it.
 *
 * An event's `start` is the instant it was recorded at, so seeking exactly
 * there drops a fan mid-goal with no build-up. Five is what the condensed reel
 * already gives a goal on its own side of the window (segments_settings, GOAL
 * before = 5), so the two agree about what watching a moment means. Arriving
 * from the Studio uses the same lead-in.
 */
const CONDENSED_LEAD_IN_SECONDS = 5;

const VideoPlayerLive = ({ gameDetails, subscriptionDetails }: any) => {
  const [chatRoom, setChatRoom] = useState<any>([]);
  const { gameId }: any = useParams();
  const [videoAway, setVideoAway] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentClip, setCurrentClip] = useState<any>(null);
  const userData = useCommonDetails();
  const [search, setSearch] = useState({ plays: "", hightlight: "" });

  // HTPTV-687: track in-game search (plays / highlights).
  useEffect(() => {
    const term = (search?.plays || search?.hightlight || "").trim();
    if (!term) return;
    const h = setTimeout(() => {
      trackSearch({
        search_term: term,
        search_context: SEARCH_CONTEXT.IN_GAME,
      });
    }, 700);
    return () => clearTimeout(h);
  }, [search?.plays, search?.hightlight]);
  const playerRef = React.useRef<any>("");
  const classes = Style;
  const videoRef: any = useRef();
  const [liniusAccessToken, setLiniusAccessToken] = useState({} as any);
  const [currentVideoData, setCurrentVideoData] = useState({} as any);
  const [isSeeking, setIsSeeking] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [checked, setChecked] = useState(false);
  const [isSkeletonList, setIsSkeletonList] = React.useState(true);
  const [thubmnails, setThumbnails] = useState([] as any);
  const [currentTime, setCurrentTime] = useState(0);
  const playerRefLinius: any = React.useRef(null);

  /*
   * The clips strip drives the game player itself: a clip's `start` is the
   * event's own position in the game video, the same asset the player is
   * already showing, so there is nothing to swap and no second timeline to
   * keep honest.
   *
   * Nine of the thirteen tenants have no search_api_url at all, and without one
   * the clips hook would fire at the SPA's own origin, so the base url gates the
   * strip: no url, no strip, no request.
   */
  const condensedGameId = search_api_url ? gameDetails?.game_id_tpe : null;


  /*
   * The two teams as the tenant knows them. The analytics side stores team ids
   * and names but no imagery, so the crests come from here, and the TPE ids are
   * what say which of them belongs on which side of a clip's score.
   */
  const condensedTeams = {
    homeTpeId: gameDetails?.home_team_id_tpe,
    awayTpeId: gameDetails?.away_team_id_tpe,
    homeLogo: gameDetails?.home_team_logo,
    awayLogo: gameDetails?.away_team_logo,
    homeShort: gameDetails?.home_team_short,
    awayShort: gameDetails?.away_team_short,
  };


  /*
   * A clip the viewer arrived to watch, from the Studio's Clips tab.
   *
   * The position is read here, because seeking the player is this page's job.
   * The MOMENT'S OWN ID goes to the Audience Layer instead, which is what opens
   * its Moments panel on the right tab with that clip picked out. This page
   * used to raise a banner naming the clip; the panel says it better, in the
   * list the clip actually lives in.
   */
  const clipStartMs = Number(searchParams.get("clip_start_ms"));
  const hasClipTarget = Number.isFinite(clipStartMs) && clipStartMs > 0;
  const seekedToClip = useRef(false);

  /*
   * Which of the panel's own tabs holds it. A clip somebody shared with this
   * fan is under "Shared" and their own is under "Mine", and the Studio knows
   * which because it drew the card. Anything else is ignored rather than
   * guessed at, so a link that outlives a rename opens the panel's default.
   */
  const momentId = searchParams.get("moment_id");
  const momentTabParam = searchParams.get("moment_tab");
  const momentTab: "mine" | "shared" | null =
    momentTabParam === "mine" || momentTabParam === "shared"
      ? momentTabParam
      : null;
  const clipTarget = useMemo(
    () => (momentId ? { momentId, tab: momentTab } : null),
    [momentId, momentTab],
  );

  /*
   * Seek there once the player has a source.
   *
   * Polled rather than done on mount: the player is built in an effect of its
   * own and loads asynchronously, so seeking straight away lands on a player
   * that has nothing to seek in. getDuration stays 0 until a source is ready,
   * which is the signal used here. The same five second lead-in as the moments
   * strip, so arriving at a clip and jumping to one look the same.
   */
  useEffect(() => {
    if (!hasClipTarget || seekedToClip.current) return;
    const id = setInterval(() => {
      const player = playerRef.current;
      if (!player || typeof player.seek !== "function") return;
      if (typeof player.getDuration === "function" && !(player.getDuration() > 0)) {
        return;
      }
      seekedToClip.current = true;
      clearInterval(id);
      jumpToTime(Math.max(0, clipStartMs / 1000 - CONDENSED_LEAD_IN_SECONDS));
    }, 250);
    return () => clearInterval(id);
  }, [hasClipTarget, clipStartMs]);

  const handleCondensedClipSelect = (clip: CondensedClip) => {
    if (clip?.start == null) return;
    jumpToTime(Math.max(0, clip.start - CONDENSED_LEAD_IN_SECONDS));
  };

  const [pageData, setPageData] = useState({} as any);
  const [page, setPage] = React.useState<any>(1);
  const [activeClip, setActiveClip] = useState("");
  const configData = useConfig();

  // The Audience Layer replaces this page's sidebar where it is switched on.
  // Absent from a tenant's config it stays off, so adding the key is what
  // enables it and no tenant changes behaviour by being left alone.
  const audienceLayerEnabled = configData?.audienceLayerEnabled === true;

  /*
   * Whether the Audience Layer takes a row of its own under the video.
   *
   * The grid stacked at MUI's `md` (900px) while the panel's stylesheet
   * switched to its stacked rules at 1023px, so between the two the panel was
   * a ~260px column trying to hold a 380px design. One breakpoint now, shared
   * with the CSS through audienceLayerLayout.ts.
   *
   * Scoped to the tenants that actually render the layer: where it is switched
   * off or nobody is signed in, the legacy sidebar renders in this slot and
   * keeps the column split it has always had.
   */
  const belowAlBreakpoint = useMediaQuery((theme: any) =>
    theme.breakpoints.down(AL_STACK_BREAKPOINT),
  );
  const {
    openColleps,
    receivedMessage,
    setReceivedMessage,
    CloseColleps,
  }: any = useContext(LoadingContext);
  const [isDownloadStarted, setIsDownLoadStarted] = useState(false);
  const [isSkeleton, setIsSKeleton] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [gameData, setGameData] = useState({} as any);
  /*
   * Built here rather than inline in the hook call below, so the boolean the
   * hook depends on (see useAudienceLayerHost's own comment on why it depends
   * on this and not on gameData itself) is one clear read of jumpToTime's own
   * page-level signal, coerced to an actual boolean rather than whatever
   * falsy/truthy shape the API answered with.
   */
  const pageIsLive = gameData?.is_live === true;
  const audienceLayerHost = useAudienceLayerHost({
    gameId,
    tenant: configData?.name ?? "",
    // Where this tenant's auth lives, so the layer can have an expired session
    // renewed rather than sitting on a 401 until the fan reloads.
    authApiUrl: configData?.api_url ?? "",
    // Sits beside VITE_AUDIENCE_LAYER_URL (the remote itself) in the per-tenant
    // env files: which API to talk to is a property of the environment this
    // host is built for, and the remote cannot know it.
    apiBaseUrl: import.meta.env.VITE_AUDIENCE_LAYER_API_URL,
    playerRef,
    // The other half of jumpToTime's own live check
    // (playerRef.current.isLive() || gameData?.is_live): the player can lag
    // behind what the page already knows, and the hook has to agree with
    // both signals, not just its own player.current.isLive().
    isLive: pageIsLive,
    // For the download check: this is the one piece of the legacy check the
    // hook cannot read on its own (the permission half rides along on the
    // signed-in user it already has through useCommonDetails).
    subscription: subscriptionDetails,
    // Opens the layer's Moments panel on the clip the viewer followed here.
    clipTarget,
  });
  const { emitClipRequest } = audienceLayerHost;

  /*
   * True only when the layer is the thing in the sidebar slot AND the window
   * is too narrow to hold it beside the video. Both halves matter: a tenant
   * with the layer switched off, or a signed-out fan, gets the legacy sidebar
   * here and must keep the column split it has always had.
   */
  const audienceLayerActive =
    audienceLayerEnabled && audienceLayerHost.context !== null;
  const stackAudienceLayer = audienceLayerActive && belowAlBreakpoint;
  /*
   * Wide enough for the panel to sit beside the video, and Classic View, which
   * is the only view with a sidebar column at all: Enhanced View overlays the
   * panel on the player instead (see bitMovingPlayer's #sidebar-video-player).
   */
  const audienceLayerBeside = audienceLayerActive && !belowAlBreakpoint && !checked;
  const [isDownloadAll, setIsDownloadAll] = useState(false);
  const [liveData, setLiveData] = useState<any>({});
  const userDetails = useCommonDetails();
  const [homeAway, setHomeAway] = useState("0");
  const [selectedTab, setSelectedTab] = useState("0");
  const [selectedTabAction, setSelectedTabAction] = useState("GOAL");
  const [allDownloadVideo, setAllDownloadVideo] = useState([] as any);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  const handleChangeClips = (e: any) => {
    const item: any = { ...currentClip };
    item[e.target.name] = e.target.value;
    setCurrentClip(item);
  };
  const handleTabChangeAction = (event: any, newValue: any) => {
    if (!newValue) {
      return;
    }
    setPage(1);
    setSelectedTabAction(newValue);
  };

  const handleTabChange = (event: any, newValue: any) => {
    if (!newValue) {
      return;
    }
    if (newValue == "HOME") {
      setHomeAway(gameDetails?.home_team_id_tpe);
    } else {
      setHomeAway(gameDetails?.away_team_id_tpe);
    }
    setSelectedTab(newValue);
  };
  function handleError(error: any) {
    toast(error?.message, { type: "error" });
  }
  const GetAllLinusDownloadVideo = async () => {
    try {
      const res = await HttpService.get(
        APIRoutes.GetAllLinusDownloadVideo + `?game_id=${gameDetails?.game_id}`,
      );

      setAllDownloadVideo(res.data.data);
    } catch (error) {}
  };

  function GetGameData(prefix: any, game_id: any) {
    var xmlHttp: any;

    xmlHttp = new XMLHttpRequest();
    if (xmlHttp == null) {
      alert("Browser does not support Ajax");
    } else {
      xmlHttp.open(
        "GET",
        "http://live-new.sharksice.timetoscore.com" +
          "/get_team_info?game_id=" +
          game_id,
        true,
      );
      xmlHttp.onreadystatechange = function ClientSideUpdate() {
        var result;
        var oCell;

        if (xmlHttp.readyState == 4) {
          result = JSON.parse(xmlHttp.responseText);
        }
      };

      xmlHttp.send(null);
    }
  }

  const [name, setName] = useState(
    `${userData.FirstName} ${userData.LastName}`,
  );
  const meetingIdFromUrl = searchParams.get("meeting_id");
  const [clipsData, setClipsData] = useState<
    {
      video_clip_uuid: string;
      start_time: number;
      end_time: number;
      name: string;
      category: string;
      game_details: any;
      createdAt: any;
      active: boolean;
      duration: number;
    }[]
  >();
  const [hightLighData, setHighLighData] = useState<
    {
      video_clip_uuid: string;
      start_time: number;
      team_logo_url: any;
      name: string;
      player_first_name: any;
      event_time: any;
      team_short_name: any;
      period: any;
      clip_name: any;
      player_jersey_number: any;
      player_last_name: any;
      player_position: any;
      duration: number;
    }[]
  >();
  const [running, setRunning] = useState(true);
  const [activeIcon, setActiveIcon] = useState<any>({ stats: true });
  function playVideo() {
    setRunning(true);

    playerRef.current.play();
  }

  const [videoList, setVideoList] = useState<any[]>([]);
  const [videoClipsData, setVideoClipsData] = useState<any>(null);
  const GetHighLightDetails = useCallback(async () => {
    setIsloading(true);
    try {
      const query: any = {
        game_ids: gameDetails?.game_id_tpe,
        page: page,
        order: "ASC",
      };

      if (selectedTab && selectedTab !== "0") {
        query["team_type"] = selectedTab;
      }
      if (selectedTabAction) {
        query["event_types"] = selectedTabAction;
      }

      const res = await HttpService.getS(
        APIRoutes.GetHSHighLights + "?" + new URLSearchParams(query),
      );

      if (res?.data?.data) {
        setActiveClip(res.data.data?.list[0]?.game_event_id);
        setVideoClipsData(res.data.data);
        setVideoList(res.data.data?.list);
        setIsloading(false);
      }
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }, [gameDetails?.game_id_tpe, selectedTab, page, selectedTabAction]);

  const GetHighLightDetailsForOld = async () => {
    try {
      const res = await HttpService.getapi(
        APIRoutes.HighLights.replace(":id", gameId),
      );

      if (res?.data?.data?.length > 0) {
        const setDataSchema = res?.data?.data?.map((el: any) => {
          return {
            video_clip_uuid: el?.uuid,
            start_time: Math.round(el?.start_time),
            team_logo_url: el?.team_logo_url,
            event_time: el?.event_time,
            name: el?.clip_name,
            period: el?.period,
            clip_name: el?.clip_name,
            player_first_name: el?.player_first_name,
            team_short_name: el?.team_short_name,
            player_jersey_number: el?.player_jersey_number,
            player_last_name: el?.player_last_name,
            player_position: el?.player_position,
            duration: el?.clip?.clip_duration,
          };
        });

        setHighLighData(setDataSchema);
      }
    } catch (error) {}
  };

  function pauseVideo() {
    setRunning(false);

    playerRef.current.pause();
  }

  const tokenProvider = async (
    selectedUsername: any,
    isModerator: any,
    avatarUrl: any,
  ) => {
    const permissions = isModerator
      ? ["SEND_MESSAGE", "DELETE_MESSAGE", "DISCONNECT_USER"]
      : ["SEND_MESSAGE"];
    const room = await HttpService.post(APIRoutes.CreateRoom, {
      game_id: gameId,
    });

    const data = {
      arn: room.data.data.Arn,
      userId: `${selectedUsername}.${uuid()}`,
      attributes: {
        username: `${selectedUsername}`,
        avatar: `${avatarUrl}`,
      },
      capabilities: permissions,
    };

    let token: any = JSON.parse(localStorage.getItem("token") as any);

    try {
      if (token) {
        if (
          isTokenExpired(token?.tokenExpirationTime) ||
          isTokenExpired(token?.sessionExpirationTime)
        ) {
          const response = await HttpService.post(APIRoutes.GetToken, data);

          const body = JSON.parse(response.data.data.body);
          token = {
            token: body.token,
            sessionExpirationTime: new Date(body.sessionExpirationTime),
            tokenExpirationTime: new Date(body.tokenExpirationTime),
          };
          searchParams.set("id", data.userId);
          setSearchParams(searchParams);
          localStorage.setItem("token", JSON.stringify(token));
        } else {
          token = token;
        }
      } else {
        const response = await HttpService.post(APIRoutes.GetToken, data);

        const body = JSON.parse(response.data.data.body);
        token = {
          token: body.token,
          sessionExpirationTime: new Date(body.sessionExpirationTime),
          tokenExpirationTime: new Date(body.tokenExpirationTime),
        };

        setSearchParams((prev: any) => [
          ...prev.entries(),
          ["id", data.userId],
        ]);

        localStorage.setItem("token", JSON.stringify(token));
      }
    } catch (error) {
      console.error("Error:", error);
    }

    return token;
  };

  const connectRoom = () => {
    // Instantiate a chat room
    let token: any = JSON.parse(localStorage.getItem("token") as any);
    if (token) {
      if (
        isTokenExpired(token?.tokenExpirationTime) ||
        isTokenExpired(token?.sessionExpirationTime)
      ) {
        const room = new ChatRoom({
          regionOrUrl: "us-east-1",
          tokenProvider: () =>
            tokenProvider(
              `${userData?.FirstName} ${userData?.LastName}`,
              false,
              userData?.ProfileImage,
            ) as any,
        });

        setChatRoom(room);

        // Connect to the chat room
        room.connect();
      }
    } else {
      const room = new ChatRoom({
        regionOrUrl: "us-east-1",
        tokenProvider: () =>
          tokenProvider(
            `${userData?.FirstName} ${userData?.LastName}`,
            false,
            userData?.ProfileImage,
          ) as any,
      });

      setChatRoom(room);

      // Connect to the chat room
      room.connect();
    }
  };
  const findCurrentClipTime = (el: any, index: any) => {
    let sum = 0;
    for (var i = 0; i < index; i++) {
      sum += parseFloat(videoList[i].duration) + 2;
    }
    return sum;
  };

  function isTokenExpired(expirationDate: any) {
    const currentDate = moment();
    const tokenExpirationDate = moment(expirationDate);

    return tokenExpirationDate.isBefore(currentDate);
  }
  const handleChangeIcon = (name: any) => {
    const item: any = {};
    item[name] = true;
    setIsEdit(false);
    setCurrentClip(null);
    setActiveIcon({ ...item });
  };

  const jumpToTime = (time: any) => {
    if (playerRef.current) {
      const maxTime = playerRef.current.getMaxTimeShift();
      if (playerRef.current.isLive() || gameData?.is_live) {
        playerRef.current.timeShift(maxTime + time);
      } else {
        playerRef.current.seek(time);
      }
    }
  };
  const handleClipPost = async (name: string) => {
    /*
     * With the Audience Layer on, the Moment is written there and this page
     * writes nothing. Exactly one writer: the layer imports this game's legacy
     * clips on its first read, so a clip written here as well would come back
     * as a second row for the same press.
     */
    if (audienceLayerEnabled) {
      emitClipRequest(name);
      handleChangeIcon("plays");
      return;
    }

    // Below this line, leave every existing statement exactly as it is: the
    // uuid, the clip object, the push onto `clips`, the POST to
    // APIRoutes.PostClipDetailas, GetClipsDetails() and handleChangeIcon. That
    // path is what nine tenants still run on until the layer reaches them, and
    // this task must not disturb it.
    try {
      const unique_id = uuid();
      const clips = clipsData || [];
      const currentPosition = Math.round(
        playerRef.current.getCurrentTime("relativetime"),
      );

      const start_time = currentPosition - 5;
      const end_time = start_time + 20;
      const postClip = {
        video_clip_uuid: unique_id,
        start_time: start_time <= 0 ? 0 : start_time,
        end_time: end_time,
        name: name,
        category: name,
        duration: 20,
        active: true,
        createdAt: moment(),
        game_details: {
          video_url:
            videoAway && gameDetails?.watch_url_away
              ? gameDetails?.watch_url_away
              : gameDetails?.watch_url,
          vod_url:
            videoAway && gameDetails?.vod_url_away
              ? gameDetails?.vod_url_away
              : gameDetails?.vod_url,
          game_id: gameId,
          away_team: gameDetails.away_team,
          home_team: gameDetails.home_team,
          game_date_time: gameDetails.game_date_time,
        },
      };

      clips?.push(postClip);
      const data = {
        game_id: gameId,
        videoUrl:
          videoAway && gameDetails?.watch_url_away
            ? gameDetails?.watch_url_away
            : gameDetails?.watch_url,
        unique_id: unique_id,
        clips: clips,
        name: `Created ${name}`,
        status: "CREATE",
      };

      const res = await HttpService.post(APIRoutes.PostClipDetailas, data);
      GetClipsDetails();
      handleChangeIcon("plays");
    } catch (error) {}
  };
  const handlePrevious = useCallback(async () => {
    console.log("Previous");
    setPage(page - 1);
  }, [page]);
  const handleNext = useCallback(async () => {
    console.log("Next");

    setPage(page + 1);
  }, [page]);
  const handleDelete = async (video_clip_uuid: any) => {
    try {
      const clips = clipsData || [];

      const postClip: any = clips?.findIndex(
        (el) => el.video_clip_uuid == video_clip_uuid,
      );
      const name = clips[postClip].name;
      clips.splice(postClip, 1);

      const data = {
        game_id: gameId,
        clips: clips,
        name: `Deleted ${name}`,
        status: "DELETE",
      };

      const res = await HttpService.post(APIRoutes.PostClipDetailas, data);
      GetClipsDetails();
    } catch (error) {}
  };

  const handleSubmitData = async (value: any, video_clip_uuid: any) => {
    if (!value.name) {
      toast.error("Name is required");
      return;
    }
    if (value?.duration < 20 || value?.duration > 60) {
      toast.error(
        "Duration should be less than 1 min and greater than 20 sec ",
      );
      return;
    }
    try {
      const clips = clipsData || [];
      const unique_id = uuid();
      const postClip: any = clips?.findIndex(
        (el) => el.video_clip_uuid == video_clip_uuid,
      );
      const name = clips[postClip].name;

      clips[postClip].active = false;

      const data2 = {
        game_id: gameId,
        clips: clips,
        name: `Deleted ${name}`,
        status: "DELETE",
      };

      const res2 = await HttpService.post(APIRoutes.PostClipDetailas, data2);

      const postClip2 = {
        video_clip_uuid: unique_id,
        start_time: value.start_time,
        end_time: value.end_time,
        name: value?.name,
        category: value?.category,
        duration: value.end_time - value.start_time || 20,
        active: true,
        createdAt: moment(),
        game_details: {
          video_url:
            videoAway && gameDetails?.watch_url_away
              ? gameDetails?.watch_url_away
              : gameDetails?.watch_url,
          game_id: gameId,
          away_team: gameDetails.away_team,
          home_team: gameDetails.home_team,
          game_date_time: gameDetails.game_date_time,
        },
      };

      clips?.push(postClip2);
      const data = {
        game_id: gameId,
        videoUrl:
          videoAway && gameDetails?.watch_url_away
            ? gameDetails?.watch_url_away
            : gameDetails?.watch_url,
        unique_id: unique_id,
        clips: clips,
        name: `Created ${name}`,
        status: "CREATE",
      };

      const res = await HttpService.post(APIRoutes.PostClipDetailas, data);

      GetClipsDetails();
      setIsEdit(false);
    } catch (error) {}
  };

  const skipForward = (time: any) => {
    if (playerRef.current) {
      const currentPosition = playerRef.current.getCurrentTime("relativetime");
      const currentPositionLive = playerRef.current.getMaxTimeShift();

      if (playerRef.current.isLive() || gameData?.is_live) {
        if (-currentPosition - currentPositionLive > time) {
          playerRef.current.timeShift(
            currentPositionLive + currentPosition + time,
          );
        }
      } else {
        playerRef.current.seek(currentPosition + time);
      }
    }
  };

  const rewind = (time: any) => {
    if (playerRef.current) {
      const currentPosition = playerRef.current.getCurrentTime("relativetime");
      const currentPositionLive = playerRef.current.getMaxTimeShift();
      if (playerRef.current.isLive() || gameData?.is_live) {
        playerRef.current.timeShift(
          currentPositionLive + currentPosition - time,
        );
      } else {
        playerRef.current.seek(currentPosition - time);
      }
    }
  };
  const getDuration = () => {
    return currentClip.end_time - currentClip.start_time;
  };
  const GetClipsDetails = async () => {
    try {
      const res = await HttpService.get(
        APIRoutes.GetVideoClipsDetails.replace(":id", gameId),
      );
      setClipsData(res.data.data);
    } catch (error) {}
  };
  const dispatch = useDispatch();
  const startConnecting = async () => {
    try {
      const meeting_id = meetingIdFromUrl;

      const meetingDetails = await HttpService.post(APIRoutes.JoinParty, {
        meetingId: meeting_id,
      });

      const connect = false ? WT.Session.connectAsAViewer : WT.Session.connect;
      const room = {
        token: meetingDetails?.data?.data?.SyncToken,
        clientName: `${userDetails.FirstName} ${userDetails.LastName}`,
        video:
          videoAway && gameDetails?.watch_url_away
            ? gameDetails?.watch_url_away
            : gameDetails?.watch_url,
      };

      connect(
        meetingDetails?.data?.data.WTToken,
        `${userDetails.FirstName} ${userDetails.LastName}`,
        {
          audio: true,
          video: true,
        },
      );

      dispatch(roomDetails.actions.setRoomDetails(room));
      handleSubmit(
        meetingDetails?.data?.data?.SyncToken,
        `${userDetails.FirstName} ${userDetails.LastName}`,
      );
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    GetClipsDetails();
    initializeSyncSdk();
    GetHighLightDetailsForOld();

    if (searchParams.get("meeting_id")) {
      handleChangeIcon("watch");
      startConnecting();
    } else {
      dispatch(roomDetails.actions.removeRoomDetails());
    }
    on("error", handleError);

    return () => {
      off("error", handleError);
    };
  }, []);
  const handleDurationChange = (dur: number, isStart: boolean) => {
    if (
      (!isStart &&
        (currentClip.end_time - currentClip.start_time + dur < 20 ||
          currentClip.end_time - currentClip.start_time + dur > 60)) ||
      (isStart &&
        (currentClip.end_time - currentClip.start_time - dur < 20 ||
          currentClip.end_time - currentClip.start_time - dur > 60))
    ) {
      toast.error("Duration should be less than 1 min and greater than 20 sec");
      return;
    }
    if (currentClip) {
      if (isStart) {
        setCurrentClip({
          ...currentClip,
          start_time:
            currentClip.start_time + dur <= 0
              ? 0
              : currentClip.start_time + dur,
        });
      } else {
        setCurrentClip({
          ...currentClip,
          end_time: currentClip.end_time + dur,
        });
      }
    }
  };

  useEffect(() => {
    if (process.env.REACT_APP_FEATURE == "true") {
      GetHighLightDetails();
      GetAllLinusDownloadVideo();
    }
  }, [GetHighLightDetails]);
  useEffect(() => {
    if (navigator.serviceWorker && liniusAccessToken?.accessToken) {
      navigator.serviceWorker.ready.then((registration) => {
        registration?.active?.postMessage({
          accessToken: liniusAccessToken?.accessToken,
          apiKey: configData.xApiKey,
        });
      });
    }
  }, [liniusAccessToken, configData]);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <CustomChangeButton checked={checked} setChecked={setChecked} />

      <Box sx={{ display: "none" }}>
        <WatchTogether />{" "}
      </Box>
      <Grid container spacing={1}>
        <Grid
          item
          {...alVideoGridProps(audienceLayerBeside, stackAudienceLayer, checked)}
        >
          <Box>
            {activeIcon?.highlight &&
            process.env.REACT_APP_FEATURE == "true" ? (
              <BitMovingPlayerLiniusv2
                sort={false}
                accessToken={liniusAccessToken?.accessToken}
                videoClipsData={videoClipsData}
                handleChangeIconAction={() => handleChangeIcon("action")}
                setRunning={setRunning}
                sideBarComponent={
                  <WatchSidebar
                    audienceLayerEnabled={audienceLayerEnabled}
                    audienceLayerHost={audienceLayerHost.context}
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    handleChangeIcon={handleChangeIcon}
                    activeIcon={activeIcon}
                    clipsButton={
                      <ClipsButtons
                        handleClipPost={handleClipPost}
                        rewind={rewind}
                        isSmall={true}
                        skipForward={skipForward}
                        playVideo={playVideo}
                        running={running}
                        pauseVideo={pauseVideo}
                      />
                    }
                    connectRoom={connectRoom}
                    gameDetails={gameDetails}
                    gameData={gameData}
                    liveData={liveData}
                    hightLighData={hightLighData}
                    getDuration={getDuration}
                    setSearch={setSearch}
                    isEdit={isEdit}
                    search={search}
                    checked={checked}
                    currentClip={currentClip}
                    handleDurationChange={handleDurationChange}
                    handleChangeClips={handleChangeClips}
                    setCurrentClip={setCurrentClip}
                    handleSubmitData={handleSubmitData}
                    handleTabChangeAction={handleTabChangeAction}
                    setIsEdit={setIsEdit}
                    handleDelete={handleDelete}
                    videoClipsData={videoClipsData}
                    clipsData={clipsData}
                    videoAway={videoAway}
                    subscriptionDetails={subscriptionDetails}
                    playerRef={playerRef}
                    GetClipsDetails={GetClipsDetails}
                    setIsDownLoadStarted={setIsDownLoadStarted}
                    isDownloadStarted={isDownloadStarted}
                    jumpToTime={jumpToTime}
                    selectedTabAction={selectedTabAction}
                    selectedTab={selectedTab}
                    handleTabChange={handleTabChange}
                    isDownloadAll={isDownloadAll}
                    thubmnails={thubmnails}
                    videoList={videoList}
                    handleChange={handleChange}
                    page={page}
                    pageData={pageData}
                    isLoading={isLoading}
                    playerRefLinius={playerRefLinius}
                    findCurrentClipTime={findCurrentClipTime}
                    chatRoom={chatRoom}
                    setIsDownloadAll={setIsDownloadAll}
                    activeClip={activeClip}
                    allDownloadVideo={allDownloadVideo}
                  />
                }
                setIsSeeking={() => setIsSeeking(!isSeeking)}
                videoUrl={
                  videoAway && gameDetails?.watch_url_away
                    ? gameDetails?.watch_url_away
                    : gameDetails?.watch_url
                }
                playerRef={playerRefLinius}
                autoPlay={true}
                setCurrentTime={setCurrentTime}
                pageData={pageData}
                page={page}
                videoList={videoList}
                currentVideoData={currentVideoData}
                setCurrentVideoData={setCurrentVideoData}
                setActiveClip={setActiveClip}
                setPage={setPage}
                checked={checked}
              />
            ) : (
              <Box>
                <BitMovingPlayer
                  checked={checked}
                  handleChangeIconAction={() => handleChangeIcon("action")}
                  gameDetails={gameDetails}
                  setRunning={setRunning}
                  sideBarComponent={
                    <WatchSidebar
                      audienceLayerEnabled={audienceLayerEnabled}
                      audienceLayerHost={audienceLayerHost.context}
                      handlePrevious={handlePrevious}
                      handleNext={handleNext}
                      handleChangeIcon={handleChangeIcon}
                      activeIcon={activeIcon}
                      videoClipsData={videoClipsData}
                      clipsButton={
                        <ClipsButtons
                          handleClipPost={handleClipPost}
                          rewind={rewind}
                          isSmall={true}
                          skipForward={skipForward}
                          playVideo={playVideo}
                          running={running}
                          pauseVideo={pauseVideo}
                        />
                      }
                      connectRoom={connectRoom}
                      gameDetails={gameDetails}
                      gameData={gameData}
                      liveData={liveData}
                      hightLighData={hightLighData}
                      getDuration={getDuration}
                      setSearch={setSearch}
                      isEdit={isEdit}
                      search={search}
                      checked={checked}
                      currentClip={currentClip}
                      handleDurationChange={handleDurationChange}
                      handleChangeClips={handleChangeClips}
                      setCurrentClip={setCurrentClip}
                      handleSubmitData={handleSubmitData}
                      handleTabChangeAction={handleTabChangeAction}
                      setIsEdit={setIsEdit}
                      handleDelete={handleDelete}
                      clipsData={clipsData}
                      videoAway={videoAway}
                      subscriptionDetails={subscriptionDetails}
                      playerRef={playerRef}
                      GetClipsDetails={GetClipsDetails}
                      setIsDownLoadStarted={setIsDownLoadStarted}
                      isDownloadStarted={isDownloadStarted}
                      jumpToTime={jumpToTime}
                      selectedTabAction={selectedTabAction}
                      selectedTab={selectedTab}
                      handleTabChange={handleTabChange}
                      isDownloadAll={isDownloadAll}
                      thubmnails={thubmnails}
                      videoList={videoList}
                      handleChange={handleChange}
                      page={page}
                      pageData={pageData}
                      isLoading={isLoading}
                      playerRefLinius={playerRefLinius}
                      findCurrentClipTime={findCurrentClipTime}
                      chatRoom={chatRoom}
                      setIsDownloadAll={setIsDownloadAll}
                      activeClip={activeClip}
                      allDownloadVideo={allDownloadVideo}
                    />
                  }
                  setIsSeeking={() => setIsSeeking(!isSeeking)}
                  videoAway={videoAway}
                  videoUrl={
                    videoAway && gameDetails?.watch_url_away
                      ? gameDetails?.watch_url_away
                      : gameDetails?.watch_url
                  }
                  playerRef={playerRef}
                  autoPlay={true}
                  audienceLayerApiUrl={import.meta.env.VITE_AUDIENCE_LAYER_API_URL}
                  audienceLayerToken={getCurrentAuth()?.AccessToken}
                />
              </Box>
            )}
          </Box>

          <Grid
            container
            spacing={1}
            sx={{ justifyContent: "center", px: { xs: 1, lg: 0 } }}
          >
            {gameDetails?.watch_url_away && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    ml: 1,
                    justifyContent: "center",
                  }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography
                      variant="body2"
                      fontWeight="600"
                      sx={{ textTransform: "none" }}
                    >
                      Home Feed
                    </Typography>
                    <Switch
                      checked={videoAway}
                      onChange={(e: any) => {
                        setVideoAway(e.target.checked);
                      }}
                    />
                    <Typography
                      fontWeight="600"
                      variant="body2"
                      sx={{ textTransform: "none" }}
                    >
                      Away Feed
                    </Typography>
                  </Stack>
                </Box>
              </Grid>
            )}
          </Grid>

          {!checked && (
            <V2Shell>
              <ClipBar
                handleClipPost={handleClipPost}
                rewind={rewind}
                skipForward={skipForward}
                playVideo={playVideo}
                pauseVideo={pauseVideo}
                running={running}
              />
            </V2Shell>
          )}

        </Grid>
        {!checked && (
          <Grid
            item
            {...alSidebarGridProps(audienceLayerBeside, stackAudienceLayer)}
          >
            <WatchSidebar
              audienceLayerEnabled={audienceLayerEnabled}
              audienceLayerHost={audienceLayerHost.context}
              handlePrevious={handlePrevious}
              handleNext={handleNext}
              handleChangeIcon={handleChangeIcon}
              activeIcon={activeIcon}
              connectRoom={connectRoom}
              videoClipsData={videoClipsData}
              gameDetails={gameDetails}
              gameData={gameData}
              liveData={liveData}
              hightLighData={hightLighData}
              getDuration={getDuration}
              setSearch={setSearch}
              isEdit={isEdit}
              search={search}
              currentClip={currentClip}
              handleDurationChange={handleDurationChange}
              handleChangeClips={handleChangeClips}
              setCurrentClip={setCurrentClip}
              handleSubmitData={handleSubmitData}
              handleTabChangeAction={handleTabChangeAction}
              setIsEdit={setIsEdit}
              handleDelete={handleDelete}
              clipsData={clipsData}
              videoAway={videoAway}
              subscriptionDetails={subscriptionDetails}
              playerRef={playerRef}
              GetClipsDetails={GetClipsDetails}
              setIsDownLoadStarted={setIsDownLoadStarted}
              isDownloadStarted={isDownloadStarted}
              jumpToTime={jumpToTime}
              selectedTabAction={selectedTabAction}
              selectedTab={selectedTab}
              handleTabChange={handleTabChange}
              isDownloadAll={isDownloadAll}
              thubmnails={thubmnails}
              videoList={videoList}
              handleChange={handleChange}
              page={page}
              pageData={pageData}
              isLoading={isLoading}
              playerRefLinius={playerRefLinius}
              findCurrentClipTime={findCurrentClipTime}
              chatRoom={chatRoom}
              setIsDownloadAll={setIsDownloadAll}
              activeClip={activeClip}
              allDownloadVideo={allDownloadVideo}
            />
          </Grid>
        )}
      </Grid>

      {/*
        Full width, below both columns.

        Keeping it out of the video column is what stops it lengthening the
        sidebar beside it: the panel fills the row the video column defines,
        and that row is the player and the clip bar alone.
      */}
      <CondensedClipsPanel
        tpeGameId={condensedGameId}
        gameIdGs={gameDetails?.game_id_gs}
        gameDetailsEnabled={configData?.v2?.gameDetails === true}
        isLive={gameDetails?.is_live === true}
        awayTeamName={{ city: gameDetails?.away_team ?? "", mascot: gameDetails?.away_team_mascot ?? "" }}
        homeTeamName={{ city: gameDetails?.home_team ?? "", mascot: gameDetails?.home_team_mascot ?? "" }}
        playerRef={playerRef}
        teams={condensedTeams}
        onSelect={handleCondensedClipSelect}
      />
    </Box>
  );
};

type CondensedClipsPanelProps = {
  tpeGameId?: number | string | null;
  gameIdGs?: number | string | null;
  /** Tenant kill switch (config.v2.gameDetails) for the "Season Context" fallback panel. */
  gameDetailsEnabled?: boolean;
  /**
   * The tenant's own `is_live` for this game. Season Context shows a team's
   * form before a game and what happened after it, and this is the page's
   * single answer to which of those it is. Taken from the player API rather
   * than the box score's own `status` so the panel cannot disagree with the
   * rest of the page about whether a game has finished.
   */
  isLive?: boolean;
  awayTeamName: TeamNameInfo;
  homeTeamName: TeamNameInfo;
  playerRef: React.MutableRefObject<any>;
  teams: StripTeams;
  onSelect: (clip: CondensedClip) => void;
};

/**
 * The clips strip, with its own shell so the React Query hook has a provider.
 * The v1 watch page has none of its own.
 *
 * The shell and the hook have to live in two components, not one. V2Shell is
 * what renders the QueryClientProvider, so a hook called in the same component
 * that renders the shell sits above the provider in the tree and never sees it.
 * Context only flows down.
 */
function CondensedClipsPanel(props: CondensedClipsPanelProps) {
  return (
    <V2Shell>
      <CondensedClipsStrip {...props} />
    </V2Shell>
  );
}

function CondensedClipsStrip({
  tpeGameId,
  gameIdGs,
  gameDetailsEnabled,
  isLive = false,
  awayTeamName,
  homeTeamName,
  playerRef,
  teams,
  onSelect,
}: CondensedClipsPanelProps) {
  const { data, isLoading: clipsLoading } = useCondensedGameClips(tpeGameId);
  const hasCondensedGame = (data?.length ?? 0) > 0;

  // Only reach for GameSheet once the clips query has settled and come back
  // empty, and only for tenants with the fallback panel switched on
  // (config.v2.gameDetails) — never while clips are still loading, and never
  // when a condensed game exists, since the strip already covers that case.
  const { data: gsDetails } = useGameSheetBoxScore(
    gameIdGs,
    Boolean(gameDetailsEnabled) && !clipsLoading && !hasCondensedGame,
  );
  const boxScore = gsDetails?.boxScore ?? null;
  const matchup = gsDetails?.matchup ?? null;

  const [currentTime, setCurrentTime] = useState(0);

  /*
   * The playback clock, sampled here rather than on the page.
   *
   * BitMovingPlayer offers no time callback and is shared with PersonalChannel,
   * so it is polled. Keeping the state in this small component means a tick
   * re-renders the strip alone; on the page it re-rendered the player and
   * everything around it several times a second, which is how a player got
   * torn down mid-clip once already.
   *
   * A quarter second is what makes the connectors between moments read as
   * filling rather than stepping, and it pairs with their transition.
   */
  useEffect(() => {
    const id = setInterval(() => {
      const player = playerRef?.current;
      if (!player || typeof player.getCurrentTime !== "function") return;
      if (typeof player.isLive === "function" && player.isLive()) return;
      const t = player.getCurrentTime();
      if (Number.isFinite(t)) setCurrentTime(t);
    }, 250);
    return () => clearInterval(id);
  }, [playerRef]);

  if (gameDetailsEnabled && !hasCondensedGame && boxScore) {
    return (
      <GameDetailsFallback
        boxScore={boxScore}
        matchup={matchup}
        isLive={isLive}
        awayTeamName={awayTeamName}
        homeTeamName={homeTeamName}
      />
    );
  }

  return (
    <CondensedGameClips
      clips={data ?? []}
      onSelect={onSelect}
      currentTime={currentTime}
      teams={teams}
    />
  );
}

export default VideoPlayerLive;
